import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { rawColors } from "../../../design-system/tokens/colors";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const Card = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  background-color: ${({ theme }) => theme.colors.surface.primary};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
  padding: ${spacing[4]};
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  flex: 1 1 auto;
  min-height: 0;

  > * {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }
`;

/**
 * Edit pencil — top-right corner of the card. Visual-only icon button.
 */
export const EditButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  margin: 0;
  padding: ${spacing[1]};
  cursor: pointer;
  position: absolute;
  top: ${spacing[3]};
  right: ${spacing[3]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  border-radius: 4px;
  transition: color ${duration.fast} ${easing.smooth}, background-color ${duration.fast} ${easing.smooth};

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.surface.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: 2px;
  }
`;
